export enum PointType {
  Lesson = 'lesson',
  Quiz = 'quiz',
  Course = 'course'
}
